import React from "react"
import PropTypes from "prop-types"
import StandardModal from '../app_components/StandardModal';
import TextInput from '../form_sections/TextInput';
import DateInput from '../form_sections/DateInput';
import TimeInput from '../form_sections/TimeInput';
import StandardButton from '../app_components/StandardButton';

class LexForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      date: '',
      time: '',
      location: '',
      location_address: '',
      otherUser: [],
      currentUser: [],
      nativeLanguage: [],
      learningLanguage: [],
      learningLanguageChoices: [],
      nativeLanguageChoices: [],
      languagesLoaded: false,
      formError: '',
      scheduleSuccess: false,
      rescheduleSuccess: false,
      meeting: ''
    }

    this.renderLanguageChoices = this.renderLanguageChoices.bind(this)
    this.renderLanguageExample = this.renderLanguageExample.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.languageChoices = this.languageChoices.bind(this)
  }

  componentDidMount() {
    this.setState({
      otherUser: this.props.otherUser,
      currentUser: this.props.currentUser,
      learningLanguage: this.props.learningLanguage,
      learningLanguageChoices: this.props.learningLanguageChoices,
      nativeLanguage: this.props.nativeLanguage,
      nativeLanguageChoices: this.props.nativeLanguageChoices,
      date: this.props.date,
      time: this.props.time,
      location: this.props.location,
      location_address: this.props.location_address,
    })
  }

  renderLanguageExample() {
    return(
      <div style={{backgroundColor: '#D7D8DA', marginRight: -12, marginLeft: -12, padding: 10, paddingLeft: 12, marginBottom: 12}}>
        <h5 className="sectionHeader" style={{textAlign: 'center', marginBottom: 10 }}>Lex = Language Experience</h5>
        <h5 className="sectionText">You and {this.state.otherUser.first_name} will meet for 1 hour. </h5>
        <h5 className="sectionText">Speak only in <span style={{fontWeight: 600}}>{this.state.learningLanguage.language}</span> for 30 minutes.</h5>
        <h5 className="sectionText">Then, speak only in <span style={{fontWeight: 600}}>{this.state.nativeLanguage.language}</span> for 30 minutes</h5>
      </div>
    )
  }

  renderLanguageChoices() {
    return (
      <div>
        <p className="label_standard">I want to practice...</p>
        {this.languageChoices()}
        <div className="sectionDivider"></div>
      </div>
    )

  }

  languageChoices() {
    return this.state.learningLanguageChoices.map((language, index) => {
        return (
          <div key={index} style={{display: 'flex', flexDirection: 'row', marginTop: 15, marginBottom: 15, minWidth: 150}}>
            <input type="radio" checked={this.state.learningLanguage === language} readOnly onClick={() => this.setState({learningLanguage: language})}/>
            <h4 style={{paddingLeft: 10, color: '#01579b'}}>{language.native}</h4>
          </div>)
    })
  }

  submitForm() {
    if(!this.props.submittingForm){
      if(this.state.date === '') {
        this.setState({
          formError: 'Missing date. What day do you want to Lex?'
        })
      } else if (this.state.time === '') {
        this.setState({
          formError: 'Missing time. What time do you want to Lex?'
        })
      }  else if (this.state.location === '') {
        this.setState({
          formError: 'Missing location. Where do you want to Lex?'
        })
      } else if (this.state.location.length < 3) {
        this.setState({
          formError: 'Location is too short. Where do you want to Lex?'
        })
      } else if (this.state.location_address === '') {
        this.setState({
          formError: 'Location address missing. What is the address? If online, what is your username?'
        })
      } else if (this.state.location_address.length < 5) {
        this.setState({
          formError: 'Location address is too short. What is the address? If online, what is your username?'
        })
      } else {


        const data = {
          requestee_id: this.state.otherUser.id,
          meeting_time: `${this.state.date.toString().split('00:', [1])}, ${this.state.time}`,
          location: this.state.location,
          location_address: this.state.location_address,
          lang_one_id: this.state.learningLanguage.id,
          lang_two_id: this.state.nativeLanguage.id
        }

        this.props.submitForm(data)

      }
    }
  }

  render() {
    return(
      <StandardModal onClose={this.props.onClose}>
        <div style={{width: 450, maxWidth: '100%'}}>
          <div
            onClick={() => this.props.onClose()}
            className="closeIcon"
            style={{position: 'absolute', right: 5, top: 7, height: 15, width: 15}}></div>
          <h3 className="sectionHeader" style={{marginBottom: 15, textAlign: 'center'}}>Schedule a Lex with {this.state.otherUser.first_name}</h3>

          {this.renderLanguageExample()}
          {this.state.learningLanguageChoices.length > 1 && this.renderLanguageChoices()}
          <DateInput
            label={'Date'}
            value={this.state.date}
            inputError={''}
            onChange={(value) => this.setState({date: value, formError: ''})}
            placeholder={''}
            minDate={Date.now()+(3600*1000*24)}
            maxDate={Date.now()+(3600*1000*24*21)}
          />
          <div style={{marginTop: 10}}/>
          <TimeInput
            label={'Time'}
            value={this.state.time}
            inputError={''}
            onChange={(value) => this.setState({time: value, formError: ''})}
            placeholder={''}
          />


          <div className="sectionDivider"></div>
          <h5 className="sectionText">Where do you want to meet?</h5>
          <h6 style={{fontStyle: 'italic', color: '#A3A3A4', marginBottom: 10, lineHeight: 1.25, marginTop: 5}}>*Due to Covid-19, we suggest meeting online, such as Skype, Facebook Messanger, WeChat, or another free video chatting service</h6>
          <TextInput
            label={'Location Name'}
            value={this.state.location}
            inputError={''}
            onChange={(value) => this.setState({location: value, formError: ''})}
            placeholder={'ex. Starbucks, Skype'}
          />
          <div style={{marginTop: 10}}/>
          <TextInput
            label={'Location Address'}
            value={this.state.location_address}
            inputError={''}
            onChange={(value) => this.setState({location_address: value, formError: ''})}
            placeholder={'ex. 123 Starbucks St, Skype name'}
          />
          <div style={{marginTop: 20}}>
            {this.state.formError != '' && <h5 className="red" style={{textAlign: 'center', marginBottom: 5}}>{this.state.formError}</h5>}
            <StandardButton
              text="Request Lex"
              size="large"
              primary={true}
              onClick={this.submitForm}
              loading={this.props.submittingForm}
             />
             <h5 style={{color: '#000000', textAlign: 'center', marginTop: 10, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Earn <span className="darkBlue" style={{paddingLeft: 5}}>5</span> <div className="lexicoin" style={{width: 25, height: 25, marginLeft: 5, marginRight: 5}}></div> per Lex</h5>
          </div>
        </div>
      </StandardModal>
    )
  }

}

export default LexForm
